import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Alert } from '@material-ui/lab';
import CancelIcon from '@material-ui/icons/Cancel';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: 'grey',
        color: theme.palette.common.white,
        padding: '2px 5px'
    },
    body: {
        fontSize: 15,
        padding: '2px 5px',
        color: theme.palette.common.black
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        cursor: 'pointer',
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover
        },
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.3)',
            color: 'white'
        }
    }
}))(TableRow);

const useStyles = makeStyles({
    table: {
        minWidth: '100%'
    }
});

export default function DepotsDetailsTable({ onClose, List, getDetailsValue }) {
    const getRowDetails = (val) => {
        try {
            getDetailsValue(val);
            onClose();
        } catch (error) {
            console.warn(error);
        }
    };
    const classes = useStyles();

    return (
        <TableContainer style={{ maxHeight: 250 }} className="custom-scroll">
            <Table className={classes.table} aria-label="customized table" stickyHeader>
                <TableBody>
                    {List.length > 0 ? (
                        List.map((row) => {
                            // let DepotDetails =;

                            return (
                                <StyledTableRow key={row.name} onClick={() => getRowDetails(row)}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.name ? (
                                            row.name
                                        ) : (
                                            <>
                                                {`${row.depotName} [${row.depotAccountCode || 'N/A'}] `}
                                                {`(${row.depotAddress1}, ${row.depotTown} , ${row.depotPostCode})`}
                                            </>
                                        )}
                                    </StyledTableCell>
                                </StyledTableRow>
                            );
                        })
                    ) : (
                        <TableRow>
                            <StyledTableCell>
                                <Alert severity="info">No Depot Found</Alert>
                            </StyledTableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
